/**
 * Footer Component - Site Information and Links
 */

import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <p>
            &copy; 2026 The Worlds Pitch. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
